import { render } from "./KbdGroup.vue?vue&type=template&id=f95a58ec&ts=true"
import script from "./KbdGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./KbdGroup.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/kbd/KbdGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f95a58ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f95a58ec', __exports__)) {
    api.reload('f95a58ec', __exports__)
  }
  
  module.hot.accept("./KbdGroup.vue?vue&type=template&id=f95a58ec&ts=true", () => {
    api.rerender('f95a58ec', render)
  })

}


export default __exports__